var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3337",
    "data-name": "Group 3337",
    transform: "translate(-214 -89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    transform: "translate(214 89)",
    fill: "#6d71f9",
    stroke: "#6d71f9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3681",
    "data-name": "Path 3681",
    d: "M.464,102.369a1.5,1.5,0,0,0,0,2.124l6,6a1.5,1.5,0,0,0,2.124-2.124l-3.441-3.441H22.525a1.5,1.5,0,1,0,0-3H5.148l3.441-3.441a1.5,1.5,0,0,0-2.124-2.124l-6,6Z",
    transform: "translate(223.975 7.074)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.fcaf7b70a7c532fb5f7ce9083f8fb150.svg";
export { ForwardRef as ReactComponent };